import Cookies from 'js-cookie';

import { ContentId, DocumentId, ExperimentId } from '@candu-ai/content/types';

import { cookieDomain } from './cookieDomain';

export interface ForcePreviewCookie {
  destination: string;
  props: {
    type: 'Experiment' | 'Content';
    intent: 'preview';
    applicationId?: number;
    id?: ContentId;
    tutorialId?: ContentId;
    slug?: string;
    documentId?: DocumentId;
    documentsToPublish?: number[];
    experimentId?: ExperimentId;
  };
}

interface SetForcePreviewCookieProps {
  url: string;
  contentId?: ContentId;
  applicationId?: number;
  documentId?: DocumentId;
  intent: 'write' | 'preview';
  slug?: string;
  documentsToPublish?: number[];
  experimentId?: ExperimentId;
  type: 'Content' | 'Experiment';
}

export const setForcePreviewCookie = ({
  url,
  applicationId,
  type,
  slug,
  contentId,
  intent,
  documentId,
  experimentId,
  documentsToPublish,
}: SetForcePreviewCookieProps) => {
  Cookies.set(
    'forcePreview',
    JSON.stringify({
      destination: url,
      props: {
        type,
        intent,
        applicationId,
        id: contentId,
        tutorialId: contentId,
        experimentId,
        slug,
        documentId,
        documentsToPublish,
      },
    } as ForcePreviewCookie),
    {
      domain: cookieDomain(),
    },
  );
};
